import conditionsFile from '../../content/dcc-core/conditions.json';
import type { ConditionContent } from './conditions.ts';

/**
 * The one place the application binds to the shipped Buff/Debuff content.
 * Everything else takes a `ConditionContent` argument, so tests and future
 * content packages can supply their own.
 */
export const dccCoreConditions = conditionsFile as unknown as ConditionContent;
